import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { ProgressSpinner } from 'primereact/progressspinner';
import { InputTextarea } from 'primereact/inputtextarea';
import useMonitorCom from './useMonitorCom';
import { RadioButton } from 'primereact/radiobutton';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Fieldset } from 'primereact/fieldset';
import { InputSwitch } from 'primereact/inputswitch';
import './MonitorCom.css';
import { TabView, TabPanel } from 'primereact/tabview';
import DataTableMon from './DateTableMon';
import PanelObs from './PanelObs';

const MonitorCom = () => {
    const {
        loadProyecto,
        proyecto,
        lstProyecto,
        setProyecto,
        loadPuesto,
        puesto,
        lstPuesto,
        setPuesto,
        loadEmpleado,
        empleado,
        lstEmpleado,
        lstColorSeg,
        colorSeg,
        codigoSeg,
        setColorSeg,
        setCodigoSeg,
        inhabControl,
        fraseSeg,
        handleCLick,
        toast,
        procesando,
        turno,
        fraseValida,
        setFraseValida,
        observacion,
        setObservacion,
        lstComunica,
        pintaFila,
        columnaEleccion,
        disabledSelect,
        cargaDetalles,
        esReemplazo,
        handleChangeEmpleado,
        lstEventosPen,
        lstEventosCerca,
        activado,
        setActivado,
        mostrarObs,
        setMostrarObs, evtTurno, handleClickObservacion,
        procesaObs,
        handlePuestoChange,
        infoAdiconal, 
        cargaPendientes
    } = useMonitorCom();

    return (
        <div className="card">
            <Toast ref={toast} />
            <Dialog style={{ width: '50vw' }} visible={mostrarObs} onHide={ () => {if (!mostrarObs) return; setMostrarObs(false);}} modal closable={false} >
                <PanelObs eventoObservado={evtTurno} funAlCerrar={handleClickObservacion} observacion={observacion} setObservacion={setObservacion} procesaObs={procesaObs} />
            </Dialog>
            <Fieldset legend="Monitor de comunicaciones">
                <div className="formgrid grid p-fluid mb-3">
                    <div className="field col-12 md:col-12">
                        { /*  lstEventosCerca.length + '-' + lstEventosPen.length  */}
                        <TabView>
                            <TabPanel header="Lista de controles POR HACER" disabled={lstEventosCerca.length === 0} headerClassName={lstEventosCerca.length !== 0 ? 'text-blinking' : ''}>
                                {cargaPendientes ? <ProgressSpinner style={{width: '25px', height: '25px'}} /> :  
                                lstEventosCerca.length !== 0 ? (<DataTableMon lstEventos={lstEventosCerca} />) : (<span></span>)}
                            </TabPanel>
                            <TabPanel header="Lista de controles PENDIENTES" disabled={lstEventosPen.length === 0} headerClassName={lstEventosPen.length !== 0 ? 'text-blinking' : ''}>
                                {cargaPendientes ? <ProgressSpinner style={{width: '25px', height: '25px'}} /> :  
                                lstEventosPen.length !== 0 ? (<DataTableMon lstEventos={lstEventosPen} />) : (<span></span>)}
                            </TabPanel>
                        </TabView>
                    </div>
                    <div className="field col-12 md:col-9">
                        <span>{}</span>
                    </div>
                    <div className="field col-12 md:col-3 flex justify-end">
                        {/*<RelojDigital /> */}
                        <label htmlFor="">Monitor activado</label>
                        <InputSwitch  checked={activado} onChange={(e) =>setActivado(e.value)} />
                    </div>
                    <div className="field col-12 md:col-6">
                        {/* Proyecto */}
                        <label htmlFor="cboProyecto">Proyecto</label>
                        {loadProyecto ? (
                            <div className="flex align-items-center">
                                <ProgressSpinner style={{ width: '20px', height: '20px' }} strokeWidth="8" />
                            </div>
                        ) : (
                            <Dropdown inputId="cboProyecto" value={proyecto} onChange={(e) => setProyecto(e.value)} options={lstProyecto} placeholder="Selecciona un proyecto" optionLabel="descripcion" filter showClear disabled={disabledSelect} />
                        )}
                    </div>
                    {/*Puesto  */}
                    <div className="field col-12 md:col-6">
                        <label htmlFor="cboPuesto">Puesto</label>
                        {loadPuesto ? (
                            <div className="flex align-items-center">
                                <ProgressSpinner style={{ width: '20px', height: '20px' }} strokeWidth="8" />
                            </div>
                        ) : (
                            <Dropdown inputId="cboPuesto" value={puesto} onChange={(evt) => handlePuestoChange(evt)} options={lstPuesto} placeholder="Selecciona un puesto" optionLabel="descripcion" showClear filter disabled={disabledSelect} />
                        )}
                    </div>
                    {/* Empleado */}
                    <div className="field col-12 md:col-6">
                        <label htmlFor="cboEmpleado">
                            Empleado <span className="italic text-orange-500">{esReemplazo}</span>{' '}
                        </label>
                        {loadEmpleado ? (
                            <div className="flex align-items-center">
                                <ProgressSpinner style={{ width: '20px', height: '20px' }} strokeWidth="8" />
                            </div>
                        ) : (
                            <Dropdown inputId="cboEmpleado" value={empleado} onChange={handleChangeEmpleado} options={lstEmpleado} placeholder="Selecciona un empleado" optionLabel="nombre" showClear filter disabled={disabledSelect} />
                        )}
                    </div>
                    {/* Turno */}
                    <div className="field col-12 md:col-6">
                        <label>Turno:</label>
                        <InputText readOnly value={turno} />
                    </div>
                    {/* Datos del Puesto */}
                    <div className="field col-12 md:col-12">
                        <label htmlFor="cboPuesto">Codigos de Marcación:</label>
                        <InputTextarea value={infoAdiconal} rows={3} cols={70} readOnly={true}/>
                    </div>
                </div>
            </Fieldset>

            <Fieldset legend="Datos de Validacion">
                <div className="formgrid grid p-fluid mb-3">
                    {/* columna 1 */}
                    <div className="field col-12 md:col-6">
                        <div className="formgrid grid p-fluid mb-3">
                            <div className="field col-12 md:col-12">
                                <label htmlFor="">Horarios</label>
                                <DataTable value={lstComunica} size="small" rowClassName={pintaFila} className="p-datatable-gridlines" loading={cargaDetalles} emptyMessage="No hay Detalles configurados">
                                    <Column field="secuencia" />
                                    <Column field="horaComunica" />
                                    <Column body={columnaEleccion} />
                                </DataTable>
                            </div>
                        </div>
                    </div>
                    {/* columna 2 */}
                    <div className="field col-12 md:col-6">
                        <div className="formgrid grid p-fluid mb-3">
                            {/* Codigo de seguridad */}
                            <div className="field col-12 md:col-12">
                                <label htmlFor="txtCodigoSeg">Código de seguridad:</label>
                                <InputText inputId="txtCodigoSeg" keyfilter="int" autoComplete="off" value={codigoSeg} onChange={(ev) => setCodigoSeg(ev.target.value)} disabled={inhabControl} placeholder="Introdusca código de seguridad" />
                            </div>
                            {/* Frase de Seguridad */}
                            <div className="field col-12 md:col-12">
                                <label htmlFor="txtFraseSeg">Frase Seguridad</label>
                                <InputText inputId="txtFraseSeg" readOnly value={fraseSeg} />
                                <div className="flex flex-wrap gap-3">
                                    <div className="flex align-items-center">
                                        <RadioButton inputId="frase01" name="fraseSeguridad" value="fraseValida" onChange={(e) => setFraseValida(e.value)} checked={fraseValida === 'fraseValida'} disabled={inhabControl} />
                                        <label htmlFor="frase01">Frase Valida</label>
                                    </div>
                                    <div className="flex align-items-center">
                                        <RadioButton inputId="frase02" name="fraseSeguridad" value="fraseInvalida" onChange={(e) => setFraseValida(e.value)} checked={fraseValida === 'fraseInvalida'} disabled={inhabControl} />
                                        <label htmlFor="frase02">Frase Invalida</label>
                                    </div>
                                </div>
                            </div>
                            {/* Color seguridad */}
                            <div className="field col-12 md:col-12">
                                <label htmlFor="cboColorSeg">Color Seguridad</label>
                                <Dropdown inputId="cboColorSeg" value={colorSeg} disabled={inhabControl} onChange={(e) => setColorSeg(e.value)} options={lstColorSeg} placeholder="Selecciona un color" optionLabel="nombreColor" filter showClear />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="formgrid grid p-fluid mb-3">
                    <div className="field col-12 md:col-4">
                        <span> </span>
                    </div>
                    {/* Boton de Validar */}
                    <div className="field col-12 md:col-4 flex flex-column justify-content-end">
                        <Button label="Validar" onClick={handleCLick} loading={procesando} disabled={inhabControl} />
                    </div>
                    <div className="field col-12 md:col-4">
                        <span> </span>
                    </div>
                </div>
            </Fieldset>
        </div>
    );
};

export default MonitorCom;
